import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { MinMaxValues } from "../../../../Constant";
import MinMaxValueForm from "./MinMaxValueForm";

const MinMaxValue = () => {
   
    return (
      <Col lg="6">
        <Card>
          <CommonCardHeader title={MinMaxValues} />
          <CardBody>
          <MinMaxValueForm/>
          </CardBody>
        </Card>
      </Col>
    );
};

export default MinMaxValue;
